export const SECTORS = [
    "Apartment",
    "Hotel",
    "Industrial",
    "Office",
    "Retail",
    "Seniors Housing & Care"
]